module.exports = __webpack_public_path__ + "static/img/02.178292b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour2/02.jpg
// module id = teNu
// module chunks = 0